import { render, staticRenderFns } from "./myPakcs.vue?vue&type=template&id=11eb5e94&scoped=true"
import script from "./myPakcs.vue?vue&type=script&lang=js"
export * from "./myPakcs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11eb5e94",
  null
  
)

export default component.exports